export default "__VITE_ASSET__nrf_hVTN__"